import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import history from "./history";


// Core Platform
import TurnTypeABM from "./components/sistema/Core/Admin/TurnTypeABM";
import UserABM from "./components/sistema/Core/Admin/UserABM";
import ScreenParams from "./components/sistema/Core/Admin/ScreenParams";
import AdminPanel from "./components/sistema/Core/Admin/AdminPanel";
// Business Modules (Turnero)
import QueueDisplay from "./components/sistema/Business/Turnero/ClientView/QueueDisplay";
import TurnTotem from "./components/sistema/Business/Turnero/ClientView/TurnTotem";
import StaffLogin from "./components/sistema/Business/Turnero/StaffView/StaffLogin";
import StaffConsole from "./components/sistema/Business/Turnero/StaffView/StaffConsole";
import StaffAdmin from "./components/sistema/Business/Turnero/StaffView/StaffAdmin";
import Auth from "./components/sistema/Core/Login/Auth";
import SuperAdminPanel from "./components/sistema/Core/SuperAdmin/SuperAdminPanel";
import VerifyEmail from "./components/sistema/Core/Login/VerifyEmail";
import WebBookingWizard from "./components/sistema/Business/Turnero/ClientView/WebBookingWizard";
import AppointmentValidation from "./components/sistema/Business/Turnero/ClientView/AppointmentValidation";
import { useParams } from "react-router-dom";

import SuperAdminStats from './components/sistema/Core/SuperAdmin/SuperAdminStats';
import SuperAdminUsers from './components/sistema/Core/SuperAdmin/SuperAdminUsers';
import SuperAdminEmpresas from './components/sistema/Core/SuperAdmin/SuperAdminEmpresas';
import SuperAdminSucursales from './components/sistema/Core/SuperAdmin/SuperAdminSucursales';
import SuperAdminStaff from './components/sistema/Core/SuperAdmin/SuperAdminStaff';
import MenuBuilderPanel from './components/sistema/Core/SuperAdmin/MenuBuilder/MenuBuilderPanel';
import QueryBuilderPanel from './components/sistema/Core/SuperAdmin/MenuBuilder/QueryBuilderPanel';
import ConnectionManager from './components/sistema/Core/SuperAdmin/MenuBuilder/ConnectionManager';
import ApiPortalPanel from './components/sistema/Core/SuperAdmin/ApiPortal/ApiPortalPanel';
import EtlStudioPanel from './components/sistema/Core/SuperAdmin/MenuBuilder/EtlStudioPanel';

import DynamicModuleResolver from './components/sistema/Core/SuperAdmin/DynamicModuleResolver';

// Wrapper for Wizard to extract sucursalId
const BookingWrapper = ({ ipserv }) => {
  const { sucursalId } = useParams();
  return <WebBookingWizard ipserv={ipserv} sucursalId={sucursalId} />;
};


function App() {
  const ipserv = process.env.REACT_APP_API_URL || '';
  //flag turnero
  sessionStorage.setItem('flag', 'true')

  return (
    <div id="root">
      <Router basename="/datamanager">
        <Routes>
          <Route path="/Core/Login" element={<Auth ipserv={ipserv} />} />
          <Route path="/verify-email" element={<VerifyEmail ipserv={ipserv} />} />
          <Route path="/reset-password" element={<Auth ipserv={ipserv} />} />

          {/* Super Admin route — Uses nested routing for the new Sidebar/Panel system */}
          <Route path="/Core/SuperAdmin" element={
            (() => {
              try {
                const p = JSON.parse(localStorage.getItem('dm_admin') || '{}');
                return p.AdminRole === 'SUPERADMIN'
                  ? <SuperAdminPanel ipserv={ipserv} />
                  : <Auth ipserv={ipserv} />;
              } catch { return <Auth ipserv={ipserv} />; }
            })()
          }>
            {/* The index route for the panel (Dashboard) */}
            <Route index element={<SuperAdminStats ipserv={ipserv} />} />

            {/* Static Modules (Defined here ONCE) */}
            <Route path="admins" element={<SuperAdminUsers ipserv={ipserv} />} />
            <Route path="companies" element={<SuperAdminEmpresas ipserv={ipserv} />} />
            <Route path="branches" element={<SuperAdminSucursales ipserv={ipserv} />} />
            <Route path="staff" element={<SuperAdminStaff ipserv={ipserv} />} />
            <Route path="menubuilder" element={<MenuBuilderPanel ipserv={ipserv} />} />
            <Route path="querybuilder" element={<QueryBuilderPanel ipserv={ipserv} />} />
            <Route path="connections" element={<ConnectionManager ipserv={ipserv} />} />
            <Route path="apiportal" element={<ApiPortalPanel ipserv={ipserv} />} />
            <Route path="etlstudio" element={<EtlStudioPanel ipserv={ipserv} />} />

            {/* Catch-all for Dynamic Modules (The resolver handles the search) */}
            <Route path="*" element={<DynamicModuleResolver ipserv={ipserv} />} />
          </Route>

          {/* Company Admin route */}
          <Route path="/Core/Admin" element={
            localStorage.getItem('dm_admin')
              ? <AdminPanel ipserv={ipserv} />
              : <Auth ipserv={ipserv} />
          } />

          <Route path="/Core/Admin/PanelTest" element={<AdminPanel ipserv={ipserv} />} />
          <Route path="/Core/Admin/Tipos" element={<TurnTypeABM ipserv={ipserv} />} />
          <Route path="/Core/Admin/Usuarios" element={<UserABM ipserv={ipserv} />} />
          <Route path="/Core/Admin/Parametros" element={<ScreenParams ipserv={ipserv} />} />
          <Route path="/Business/TurneroView/:type" element={<QueueDisplay ipserv={ipserv} />} />
          <Route path="/Business/TurneroTotem" element={<TurnTotem ipserv={ipserv} />} />
          <Route path="/Staff/Portal" element={<StaffAdmin ipserv={ipserv} />} />
          <Route path="/booking/:sucursalId" element={<BookingWrapper ipserv={ipserv} />} />
          <Route path="/validate-appointment" element={<AppointmentValidation ipserv={ipserv} />} />
          <Route path="/" element={<Auth ipserv={ipserv} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

